import JSONstringifyWithoutNulls from "./JSONstringifyWithoutNulls";
export default class RequestBase extends JSONstringifyWithoutNulls {
    constructor(pageId, moduleId) {
        super();
        this.PageID = null;
        this.ModuleID = null;
        if (pageId === null && moduleId === null) {
            throw new Error('pageId and moduleId cannot be null');
        }
        else {
            this.PageID = pageId;
            this.ModuleID = moduleId;
        }
    }
}
